<template>
  <v-navigation-drawer
    ref="detailsDrawer"
    v-if="detailsDrawer"
    right
    v-model="detailsDrawer"
    :clipped="true"
    app
    :width="optionsChanged.width"
    height="100%"
  >
    <v-tooltip top v-if="!hideCloseButton">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          @click="detailsDrawer = false"
          name="details-drawer-close"
          class="Drawer-Close-Button"
          absolute
          right
          fab
          small
          depressed
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>

      <span>Close Drawer</span>
    </v-tooltip>

    <slot name="details" />
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Object,
      default: () => ({
        width: 500,
        borderSize: 3,
      }),
    },

    resizable: {
      type: Boolean,
      default: false,
    },

    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(val) {
      if (val) {
        setTimeout(() => {
          document.addEventListener("click", this._handleOutsideClick);
        }, 0);
        if (this.resizable) {
          let interval = setInterval(() => {
            if (this.$refs.detailsDrawer) {
              clearInterval(interval);
              this.setBorderWidth();
              this.setEvents();
            }
          }, 500);
        }
      } else {
        document.removeEventListener("click", this._handleOutsideClick);
      }
    },
  },

  computed: {
    detailsDrawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    optionsChanged: {
      get() {
        return this.options;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    maxWidth() {
      return window.innerWidth;
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this._handleOutsideClick);
  },
  methods: {
    _handleOutsideClick(e) {
      const drawerEl = this.$refs.detailsDrawer && this.$refs.detailsDrawer.$el;
      if (!drawerEl) return;
      // Skip when any dialog or menu is open — clicks inside those should not close the drawer
      if (
        e.target.closest(".v-menu__content") ||
        e.target.closest(".v-dialog__content") ||
        e.target.closest(".v-overlay") ||
        document.querySelector(".v-dialog__content .v-dialog--active") ||
        document.querySelector(".v-overlay--active")
      ) {
        return;
      }
      if (!drawerEl.contains(e.target)) {
        this.detailsDrawer = false;
      }
    },
    setBorderWidth() {
      let i = this.$refs.detailsDrawer.$el.querySelector(
        ".v-navigation-drawer__border"
      );
      i.style.width = this.options.borderSize + "px";
      i.style.cursor = "ew-resize";
      i.style.backgroundColor = "#BDBDBD";
    },
    setEvents() {
      const maxWidth = window.innerWidth / 2;
      const minSize = 500;
      const el = this.$refs.detailsDrawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      const vm = this;
      const direction = el.classList.contains("v-navigation-drawer--right")
        ? "right"
        : "left";

      const resize = (e) => {
        e.preventDefault();
        document.body.style.cursor = "ew-resize";
        let f =
          direction === "right"
            ? document.body.scrollWidth - e.clientX
            : e.clientX;
        if (f < maxWidth && f > minSize) {
          el.style.width = f + "px";
        }
      };

      drawerBorder.addEventListener(
        "mousedown",
        (e) => {
          e.preventDefault();
          if (e.offsetX < minSize) {
            el.style.transition = "initial";
            document.addEventListener("mousemove", resize, false);
          }
        },
        false
      );

      document.addEventListener(
        "mouseup",
        (e) => {
          e.preventDefault();
          el.style.transition = "";

          this.optionsChanged.width = el.style.width;
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
  },
};
</script>

<style></style>
